// extracted by mini-css-extract-plugin
module.exports = {"v-loading":"loading-view_v-loading__wjq5H","v-loading_img":"loading-view_v-loading_img__6zXFN","-is-loaded":"loading-view_-is-loaded__jd16x"};